import { initializeApp, getApps, getApp } from 'firebase/app'
import {
  getAuth,
  GoogleAuthProvider,
  OAuthProvider,
  setPersistence,
  browserLocalPersistence,
} from 'firebase/auth'
import {
  initializeFirestore,
  persistentLocalCache,
  persistentMultipleTabManager,
} from 'firebase/firestore'
import { getFunctions } from 'firebase/functions'
import { getStorage } from 'firebase/storage'

// Public web config for the shared `liverbuddy-app` Firebase project.
// Same values funnel/website use — public by design.
const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY || 'AIzaSyBJfOUai06XeRbQVhbnoAmX0XuxxjP3PZY',
  // Branded auth domain: OAuth popups + provider emails say "web.liverly.app"
  // instead of "liverbuddy-app.firebaseapp.com". This Hosting site serves the
  // reserved /__/auth/* handler automatically. Requires (one-time, consoles):
  // the GCP web OAuth client lists https://web.liverly.app as a JS origin and
  // .../__/auth/handler as a redirect URI, and the Apple Services ID registers
  // the same return URL.
  authDomain: 'web.liverly.app',
  projectId: 'liverbuddy-app',
  storageBucket: 'liverbuddy-app.firebasestorage.app',
  messagingSenderId: '795030498486',
  appId: import.meta.env.VITE_FIREBASE_APP_ID || '1:795030498486:web:dc4e7e854b388df3fe4a17',
  measurementId: 'G-529PT71RGB',
}

export const app = getApps().length ? getApp() : initializeApp(firebaseConfig)

export const auth = getAuth(app)

// Offline persistence (IndexedDB) — older users on flaky connections keep working.
// ignoreUndefinedProperties matches the mobile writers' strip-undefined behavior:
// analysis payloads have optional nutrients, and Firestore rejects undefined otherwise.
export const db = initializeFirestore(app, {
  localCache: persistentLocalCache({ tabManager: persistentMultipleTabManager() }),
  ignoreUndefinedProperties: true,
})

export const functions = getFunctions(app)
export const storage = getStorage(app)

// Keep the session across reloads/tabs.
void setPersistence(auth, browserLocalPersistence).catch(() => {
  /* falls back to in-memory if storage is unavailable */
})

export const googleProvider = new GoogleAuthProvider()

export const appleProvider = new OAuthProvider('apple.com')
appleProvider.addScope('email')
appleProvider.addScope('name')
